import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Switch, Select, Form, Input, DatePicker } from 'antd';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
import { LeftCircleOutlined } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import getTerminalsByOrg from '../../hooks/getTerminalsByOrg';
import getDenomById from '../../hooks/getDenomById';
console.log(app);
const { TextArea } = Input;

const EditDenomination = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [denominationObj, setdemoninationObj] = useState({});
  const [organizationId, setOrganizationId] = useState('');
  const [denominationId,setDenominationId]=useState('');
  const [causeList, setCauseList] = useState([]);
  const [org,setOrg]=useState('')
  let navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(user);
  let denomId = JSON.parse(localStorage.getItem('denominationId'));
  console.log(denomId)
 denomId? useEffect(()=>{
    const getData=async(id)=>{
      console.log(id);
      const res = await axios.get(`${app.URL}/denomination/view/${id}`,{headers:{auth:token}});
      console.log(res);
      setOrganizationId(res?res.data.data.organizationId:null)
    setdemoninationObj(res?res.data.data:null)
    }
    getData(denomId);
  },[]):" "


  // let denomAPIRes=getDenomById(denomId);
  // let denomObj=denomAPIRes.response?denomAPIRes.response.data:{}  
  // if(user.userType==="O")setOrganizationId(user.organizationId)
  
 useEffect(() => {
    const getData = async (id) => {
      console.log('getData')
      const causeResp = await axios.get(`${app.URL}/cause/viewbyorg?orgId='${id}'&isActive=1`, { headers: { auth: token } });
      const causes=causeResp?causeResp.data.data:[];
      setCauseList(causes)
    };
    getData(organizationId);
  }, [organizationId])


  const token = getTokenfromUserObj();
  const uploadData = async (uploadObj) => {
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/denomination/update/${denomId}`, uploadObj, { headers: { auth: token } });
      setAddUserResp(res.data);
      setTimeout(() => {
        user.userType==="A"?navigate('/denominations/view'):navigate('/denomination/view');
      }, 1000);

    } catch (err) {
      console.log(err);
      // if (err) console.log(err.response.data.message);
      // else retrun;
    }
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onFinish = (values) => {
    console.log('Success:', values);
    // o={...values}
    // console.log(values.validityDate.format().split('T')[0]);
    setUploadObj({
      organizationId:user.userType==="O"?user.organizationId:values.organizationId ? values.organizationId : null,
      causeId:values.causeId ? values.causeId : null,
      amount: values.amount ? values.amount : null,
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId: user.userId,
    });
    setShow(true);
  };
  console.log(uploadObj);
  const submitData = () => {
    console.log('calling');
    if (Object.keys(uploadObj).length > 0) {
      uploadData(uploadObj);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);

  const organizationValue = (value) => {
    console.log('Organization Value calling');
    console.log(value);
    setOrganizationId(value);
  };
  function goBack() {
    user.userType==="A"?navigate('/denominations/view'):navigate('/denomination/view');
  }
  window.addEventListener('popstate', goBack);
  console.log(org)

  return (
    <div class='container'>
      <div class='row mt-4 w-75 tbl'>
        <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            <LeftCircleOutlined
              onClick={() => {
                user.userType==="A"?navigate('/denominations/view'):navigate('/denomination/view');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Denomination')} </h2>
          </div>{' '}
        </div>
        <div class='col mb-5 w-50'>
          <div class='col-lg-9 align-self-center mt-4 mb-4'>
          {denominationObj&&denominationObj.organizationId? <Form
              name='basic'
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              style={{
                maxWidth: 600,
              }}
              initialValues={{
                remember: true,
                ['id']: 1,
                ['organizationId']:denominationObj.organizationId,
                ['causeId']: denominationObj.causeId,
                ['amount']:denominationObj.amount,
                ['isActive']: denominationObj.isActive===1?true:false,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              {/* Select box for Organization */}
             {user.userType==="A"? <Form.Item
                colon={false}
                label='Organization'
                name='organizationId'
                rules={[
                  {
                    required: true,
                    message: 'Select Organization',
                  },
                ]}
              >
                <Select
                  style={{
                    width: 280,
                  }}
                  placeholder='Select Organization'
                  onChange={(value) => organizationValue(value)}
                >
                  {orgs
                    ? orgs.map((org) => {
                        return (
                          <Option key={org.organizationId} value={org.organizationId}>
                            {org.organizationName}
                          </Option>
                        );
                      })
                    : ' '}
                </Select>
              </Form.Item>  :" "} 
              {denominationObj.causeId  ? (
                <Form.Item
                  colon={false}
                  label='Cause'
                  name='causeId'
                  onChange={(e) => {
                    console.log(e);
                  }}
                  rules={[
                    {
                      required: true,
                      message: 'Select Cause',
                    },
                  ]}
                >
                  <Select
                    style={{
                      width: 280,
                    }}
                    placeholder='Select Cause'
                    // onChange={(value) => {
                    //   setOrg(value);
                    // }}
                  >
                    {causeList
                      ? causeList.map((data) => {
                        if(data.status=="Active"){
                          return (
                            <Option key={data.causeId} value={data.causeId}>
                              {data.cause}
                            </Option>
                          );
                        }
                        })
                      : ' '}
                  </Select>
                </Form.Item>
              ) : (
                ' '
              )}
              <Form.Item
                label='Amount'
                name='amount'
                // defaultValue='1'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Enter Amount',
                  },
                ]}
              >
                <Input placeholder='Enter Amount' />
              </Form.Item>
              <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                <Switch />
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                {addUserResp.statusCode === 200 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Success</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : addUserResp.statusCode === 400 ? (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title className='text-center'>Failed</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{addUserResp.data.message}</Modal.Body>
                    <Modal.Footer></Modal.Footer>
                  </Modal>
                ) : (
                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Are you sure you want to Update Denomination?</Modal.Body>
                    <Modal.Footer>
                      <Button variant='secondary' onClick={handleClose}>
                        Cancel
                      </Button>
                      <Button variant='primary' htmlType='submit' onClick={submitData}>
                        Save Changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
                <button type='primary' class='btn btn-primary button' htmlType='submit'>
                  Update
                </button>
              </Form.Item>
            </Form> :" "} 
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDenomination;
